import { render, staticRenderFns } from "./AlListGroup.vue?vue&type=template&id=664a7222&"
import script from "./AlListGroup.vue?vue&type=script&lang=js&"
export * from "./AlListGroup.vue?vue&type=script&lang=js&"
import style0 from "./AlListGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports